import './menu';
import './quiz';
import './TripWeather';
import './Carousel';
import './carouselBanners';
import './LastMinuteTopOffers';
import './LastMinuteLineTopOffers';
import './Qna';
import './HomepageTopOffers';
import './Newsletter';
import './Splide';
import './gtm-script';

// Trip detail information
const expandDetailTrip = document.querySelectorAll('.js-expand-detail-trip-information');
if (expandDetailTrip) {
    expandDetailTrip.forEach(function (expand) {
        expand.addEventListener('click', function () {
            this.closest('.detail-trip-information').classList.add('is-open');
        });
    });
}

// Trip share button
const tripActions = document.querySelector('.js-detail-trip-actions');
if (tripActions) {
    tripActions.addEventListener('click', function() {
        this.classList.toggle('is-open');

        if (this.classList.contains('is-open')) {
            document.querySelectorAll('.js-detail-trip-actions.is-open').forEach(function(el) {
                if (el !== tripActions) {
                    el.classList.remove('is-open');
                    el.removeAttribute('data-outside-click-attached');
                }
            });
        }

        if (!this.hasAttribute('data-outside-click-attached')) {
            this.setAttribute('data-outside-click-attached', 'true');
        }
    });
}

const scrollRightButtons = document.querySelectorAll('.js-scroll-right');
if (scrollRightButtons) {
    scrollRightButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            const container = document.querySelector(button.getAttribute('data-target'));
            const step = button.getAttribute('data-step') || 200;

            container.scrollLeft += parseInt(step);
        });
    });
}

const scrollLeftButtons = document.querySelectorAll('.js-scroll-left');
if (scrollLeftButtons) {
    scrollLeftButtons.forEach(function (button) {
        const container = document.querySelector(button.getAttribute('data-target'));
        const step = button.getAttribute('data-step') || 200;

        button.addEventListener('click', function () {
            container.scrollLeft -= parseInt(step);
        });
    });
}
